import { render } from "./BrandPharmonia.vue?vue&type=template&id=130e1df0"
import script from "./BrandPharmonia.vue?vue&type=script&lang=ts"
export * from "./BrandPharmonia.vue?vue&type=script&lang=ts"

import "./BrandPharmonia.vue?vue&type=style&index=0&id=130e1df0&lang=scss"
script.render = render

export default script